export default "__VITE_ASSET__DW40UNQC__"